import React from "react";

import styles from "components/Footer.module.scss";
import HintedContent from "components/HintedContent";
import styleConstants from "constants.module.scss";

const JUICY_LENGTH = parseInt(styleConstants.juicyLength, 10);
const Z_INDEX_POPOVER = parseInt(styleConstants.zIndexPopover, 10);

interface Props {
  className?: string;
}

const Footer = ({ className }: Props) => {
  const calendarIcon = (
    <a
      href="https://calendar.google.com/calendar?cid=ZHVvbGluZ28uY29tXzg5OGxidHZwYjNjcHByb2V1MjF1YzFuMHI4QGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20"
      rel="noopener noreferrer"
      target="_blank"
    >
      {/* Calendar icon from https://fonts.google.com/icons?selected=Material%20Icons%20Outlined%3Atoday%3A */}
      <svg
        className={styles.calendarIcon}
        fill="#4B4b4b"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zM7 11h5v5H7z" />
      </svg>
    </a>
  );

  return (
    <div className={className}>
      <HintedContent
        direction="up"
        offset={3 * JUICY_LENGTH}
        shortText="How fresh is my data?"
        zIndex={Z_INDEX_POPOVER / 2}
      >
        <div className={styles.info}>
          {/* TODO (TRI-5250): Replace this notice with a page showing the update times of everything */}
          Metrics update every 10 minutes to avoid overwhelming the metrics
          dashboard. Android and iOS app statuses update every 10 minutes to
          avoid being rate-limited. Everything else we fetch live or cache for a
          short time.
        </div>
      </HintedContent>
      <a
        href="https://github.com/duolingo/release-dashboard"
        rel="noopener noreferrer"
        target="_blank"
      >
        <svg className={styles.github} viewBox="0 0 512 512">
          <path d="M256 70.7c-102.6 0-185.9 83.2-185.9 185.9 0 82.1 53.3 151.8 127.1 176.4 9.3 1.7 12.3-4 12.3-8.9V389.4c-51.7 11.3-62.5-21.9-62.5-21.9 -8.4-21.5-20.6-27.2-20.6-27.2 -16.9-11.5 1.3-11.3 1.3-11.3 18.7 1.3 28.5 19.2 28.5 19.2 16.6 28.4 43.5 20.2 54.1 15.4 1.7-12 6.5-20.2 11.8-24.9 -41.3-4.7-84.7-20.6-84.7-91.9 0-20.3 7.3-36.9 19.2-49.9 -1.9-4.7-8.3-23.6 1.8-49.2 0 0 15.6-5 51.1 19.1 14.8-4.1 30.7-6.2 46.5-6.3 15.8 0.1 31.7 2.1 46.6 6.3 35.5-24 51.1-19.1 51.1-19.1 10.1 25.6 3.8 44.5 1.8 49.2 11.9 13 19.1 29.6 19.1 49.9 0 71.4-43.5 87.1-84.9 91.7 6.7 5.8 12.8 17.1 12.8 34.4 0 24.9 0 44.9 0 51 0 4.9 3 10.7 12.4 8.9 73.8-24.6 127-94.3 127-176.4C441.9 153.9 358.6 70.7 256 70.7z" />
        </svg>
      </a>
      <HintedContent
        direction="up"
        shortText={calendarIcon}
        zIndex={Z_INDEX_POPOVER / 2}
      >
        <div className={styles.infoReleaseCalendar}>Release Calendar</div>
      </HintedContent>
      <a
        href="https://duolingo.slack.com/archives/CV7F8ED42"
        rel="noopener noreferrer"
        target="_blank"
      >
        #proj-release-dashboard
      </a>
    </div>
  );
};

export default Footer;
